/**
 * ProductButtonOption - button-style variant option selector.
 * Custom element: <product-button-option>
 *
 * Attributes (from $info):
 *   name      String  -
 *   selected  String  -
 *   position  Number  -
 *
 * Refs:
 *   [data-ref="buttonItem"]  (required)
 *   [data-ref="labelSelectedOption"]  (optional)
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import "./component-ProductOptionPicker.js";
import { ThemeComponent } from "./theme.js";
import { dist } from "./vendor.js";
import "./component-ProductButtonOption.js";
import "./component-ProductDropdownOption.js";
import "./component-FakeDropdown.js";
class ProductButtonOption extends ThemeComponent {
  constructor() {
    super(...arguments), this.valuesWithoutStock = [], this.valuesWithoutVariant = [], this._onChange = new dist.SimpleEventDispatcher();
  }
  get onChange() {
    return this._onChange.asEvent();
  }
  init() {
    for (const buttonElement of this.buttonItem) {
      const inputElement = buttonElement.querySelector("input");
      this.$listen(inputElement, "change", () => {
        if (!inputElement.checked) return;
        const selectedValue = inputElement.value;
        this.select(selectedValue), this.labelSelectedOption && selectedValue && (this.labelSelectedOption.textContent = selectedValue.toLowerCase()), this._onChange.dispatch(selectedValue);
      });
    }
  }
  select(value) {
    this.selected = value, this.updateButtonStyles();
  }
  updateSelectedValueText() {
    this.labelSelectedOption && (this.labelSelectedOption.textContent = this.selected.toLowerCase());
  }
  updateBasedOnSelector(selector) {
    this.valuesWithoutStock = selector.options[this.position - 1].values.filter(optionValue => optionValue.outOfStock).map(optionValue => optionValue.value), this.valuesWithoutVariant = selector.options[this.position - 1].values.filter(optionValue => !optionValue.variantExists).map(optionValue => optionValue.value);
  }
  updateButtonStyles() {
    for (const buttonElement of this.buttonItem) {
      const buttonValue = buttonElement.querySelector("input").value,
        isSelected = (buttonValue || null) == this.selected,
        isOutOfStock = this.valuesWithoutStock.indexOf(buttonValue) > -1,
        hasNoVariant = this.valuesWithoutVariant.indexOf(buttonValue) > -1;
      if (buttonElement.classList.remove("is-active", "product-button-option__button-item--no-variant", "product-button-option__button-item--sold-out"), hasNoVariant) {
        buttonElement.classList.add("product-button-option__button-item--no-variant");
        return;
      }
      isSelected && buttonElement.classList.add("is-active"), isOutOfStock && buttonElement.classList.add("product-button-option__button-item--sold-out");
    }
  }
}
setFunctionName(ProductButtonOption, "ProductButtonOption");
const propertyTypes = {
  String,
  Number
};
ProductButtonOption.prototype.$name = "ProductButtonOption";
ProductButtonOption.prototype.$info = JSON.parse('{"name":"ProductButtonOption","meta":{"isLegacy":false,"selector":"product-button-option"},"props":[{"attr":"name","reflectAttr":false,"propertyKey":"name","propertyType":"String","propertyTypeName":"String","propertyTsTypeName":"string"},{"attr":"selected","reflectAttr":false,"propertyKey":"selected","propertyType":"String","propertyTypeName":"String","propertyTsTypeName":"string"},{"attr":"position","reflectAttr":false,"propertyKey":"position","propertyType":"Number","propertyTypeName":"Number","propertyTsTypeName":"number"}],"refs":[{"selector":"[data-ref=\\"buttonItem\\"]","required":true,"propertyKey":"buttonItem","propertyType":"Array","propertyTypeName":"Array","propertyTsTypeName":"HTMLElement[]"},{"selector":"[data-ref=\\"labelSelectedOption\\"]","required":false,"propertyKey":"labelSelectedOption","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"HTMLElement"}]}');
ProductButtonOption.prototype.$info.component = ProductButtonOption;
for (const prop of ProductButtonOption.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("Product/ProductButtonOption.ts", {
  ProductButtonOption: ProductButtonOption
}, void 0);
export { ProductButtonOption };